module.exports = __webpack_public_path__ + "static/media/ceiling_fondo_oscuro.88b5daff.jpg";